// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__135jw","item":"PaymentsMobile_item__28Is-","label":"PaymentsMobile_label__1jU2y","amount":"PaymentsMobile_amount__2k6ba"};